import { Grid } from 'antd';
import { getMCRTData, getRecentlySoldNfts } from 'api/utils';
import bnbLogo from 'assets/icon-bnb.png';
import mcrtLogo from 'assets/icon-mcrt.png';
import axios from 'axios';
import { BigNumber, ethers } from 'ethers';
import { useMagicNFT } from 'hooks/useContract';
import TimeAgo from 'javascript-time-ago';
import en from 'javascript-time-ago/locale/en';
import { useEffect, useState } from 'react';
import { Nav } from 'react-bootstrap';
import { BiChevronRight } from 'react-icons/bi';
import { useDispatch } from 'react-redux';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { fetchMagicNftsAsync } from 'state/action';
import { useNFTMarketplaceState } from 'state/hooks';
import { getNftContractAddress, setData } from 'state/nftMarketplace';
import { getNameBgColor } from 'utils/nftHelper';
import NftMedia from 'components/NftMedia';
import { getMcrtPrice } from '../../api/utils/index';
import people from '../../assets/icon-people.png';
import receipt from '../../assets/icon-receipt.png';
import shop from '../../assets/icon-shop.png';
import swordsIcon from '../../assets/icon-swords.svg';
// styles
import moment from 'moment';
import InventoryItem from 'pages/NFTInventory/NFTItem';
import SmallCardSkeleton from 'pages/NFTMain/components/SmallSkeleton';
import './index.scss';

TimeAgo.addDefaultLocale(en);

const E18 = BigNumber.from(10).pow(18);
const E9 = BigNumber.from(10).pow(9);

const chainId = Number(process.env.REACT_APP_CHAIN_ID) || 97;

const NFTMarketplace = (props) => {
  // const [activeTimeBtn, setActiveTimeBtn] = useState('24h');
  const [listedType, setListedType] = useState('characters');
  // const [soldType, setSoldType] = useState('characters');
  const [MCRTPrice, setMCRTPrice] = useState(0);
  const [soldNfts, setSoldNfts] = useState([]);
  const [recentNfts, setRecentNfts] = useState([]);
  const [MCRTData, setMCRTData] = useState({});
  const [BNBPrice, setBNBPrice] = useState(0);
  // const { account } = useWeb3React();
  const { listedNfts, collection } = useNFTMarketplaceState();
  const location = useLocation();
  const ctNFT = useMagicNFT();
  const breakpoint = Grid.useBreakpoint();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(true)
  useEffect(() => {
    setTimeout(() => {
      setLoading(false)
    }, 2000);
    if (listedNfts?.length > 0) {
      setLoading(false)
    }
  }, [listedNfts])

  function timeDifference(current, previous) {
    var msPerMinute = 60 * 1000;
    var msPerHour = msPerMinute * 60;
    var msPerDay = msPerHour * 24;
    var msPerMonth = msPerDay * 30;
    var msPerYear = msPerDay * 365;

    var elapsed = current - previous;

    if (elapsed < msPerMinute) {
      return Math.round(elapsed / 1000) + ' seconds ago';
    } else if (elapsed < msPerHour) {
      if (Math.round(elapsed / msPerMinute) === 1) {
        return Math.round(elapsed / msPerMinute) + ' minute ago';
      } else {
        return Math.round(elapsed / msPerMinute) + ' minutes ago';
      }
    } else if (elapsed < msPerDay) {
      if (Math.round(elapsed / msPerHour) === 1) {
        return Math.round(elapsed / msPerHour) + ' hour ago';
      } else {
        return Math.round(elapsed / msPerHour) + ' hours ago';
      }
    } else if (elapsed < msPerMonth) {
      if (Math.round(elapsed / msPerDay) === 1) {
        return Math.round(elapsed / msPerDay) + ' day ago';
      } else {
        return Math.round(elapsed / msPerDay) + ' days ago';
      }
    } else if (elapsed < msPerYear) {
      if (Math.round(elapsed / msPerMonth) === 1) {
        return Math.round(elapsed / msPerMonth) + ' month ago';
      } else {
        return Math.round(elapsed / msPerMonth) + ' months ago';
      }
    } else {
      if (Math.round(elapsed / msPerYear) === 1) {
        return Math.round(elapsed / msPerYear) + ' year ago';
      } else {
        return Math.round(elapsed / msPerYear) + ' years ago';
      }
    }
  }

  const goToNftDetail = (nft) => {
    const tokenID = nft?.tokenID ?? nft;
    const contract = nft?.contractAddress || getNftContractAddress();
    dispatch(setData({ selectedNft: typeof nft === 'object' && nft != null ? nft : null }));
    localStorage.setItem('prevPath', location.pathname);
    navigate(`/marketplace/${contract}/${tokenID}`);
  };

  const onBtnMint = () => {
    let path = `/nft_mint`;
    navigate(path);
  };

  const onBtnMarketplace = () => {
    navigate(`/marketplace/explorer`);
  };

  function redirect(path) {
    navigate(path);
  }

  // MCRT uses 9 decimals (E9) on all chains; BNB uses 18 (E18).
  function showAmount(amount, isMCRT) {
    const balance = isMCRT
      ? BigNumber.from(amount.toString()).mul(100).div(E9).toNumber() / 100
      : BigNumber.from(amount.toString()).mul(100).div(E18).toNumber() / 100;

    return balance;
  }

  function numberWithCommas(x) {
    var parts = x.toString().split('.');
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return parts.join('.');
  }

  function returnRarity(selectedNft) {
    const rarity = selectedNft.attributes.find(
      (it) => it.trait_type === 'rarity',
    )?.value;

    return rarity;
  }

  function returnClass(selectedNft) {
    let classType = '';
    if (selectedNft.name.includes('Arcana')) {
      classType = 'Arcana';
    } else if (selectedNft.name.includes('Knight')) {
      classType = 'Knight';
    } else if (
      selectedNft.contractAddress ===
      '0xafc9f628220eb9efc313ded8d131253f633f6be9'
    ) {
      return undefined;
    } else {
      classType = 'Hunter';
    }
    return classType;
  }

  // Market Cap & Total Volume: CoinGecko. NFT Holders: NFT contract totalSupply().
  // Fetched separately so one failure (e.g. CoinGecko 429, contract not ready) does not block the others.
  function getMCRTInfo() {
    getMCRTData()
      .then((response) => {
        const marketCap = response?.market_data?.market_cap?.usd;
        const totalVolume = response?.market_data?.total_volume?.usd;
        setMCRTData((prev) => ({
          ...prev,
          ...(marketCap != null && { marketCap }),
          ...(totalVolume != null && { totalVolume }),
        }));
      })
      .catch(() => {
        setMCRTData((prev) => ({ ...prev }));
      });

    if (ctNFT?.methods?.totalSupply) {
      ctNFT.methods
        .totalSupply()
        .call()
        .then((holders) => {
          setMCRTData((prev) => ({ ...prev, holders: holders ?? prev.holders }));
        })
        .catch(() => {});
    }
  }

  async function getBNBPrice() {
    const priceData = await axios.get(
      `https://api.binance.com/api/v3/ticker/price?symbol=BNBUSDT`,
    );

    if (priceData.data) {
      setBNBPrice(Number(priceData.data.price));
    }
  }

  const getCurrentPrice = (inventoryData) => {
    const today = new Date();
    let data = { ...inventoryData };

    if (
      !data ||
      !data.startingPrice ||
      !data.endingPrice ||
      !data.duration ||
      !data.startAt
    )
      return 0;

    data.startingPrice = Number(data.startingPrice).toLocaleString('fullwide', {
      useGrouping: false,
    });

    data.endingPrice = Number(data.endingPrice).toLocaleString('fullwide', {
      useGrouping: false,
    });
    if (!data.isMCRT) {
      const bnbAmt = ethers.utils.formatEther(
        ethers.BigNumber.from(`${data.startingPrice}`).add(
          ethers.BigNumber.from(
            Math.min(
              data.duration,
              Math.ceil(today.getTime() / 1000.0 - data.startAt),
            ),
          )
            .mul(
              ethers.BigNumber.from(`${data.endingPrice}`).sub(
                ethers.BigNumber.from(`${data.startingPrice}`),
              ),
            )
            .div(ethers.BigNumber.from(data.duration)),
        ),
      );

      return Number(bnbAmt);
    } else {
      const mcrtAmt = ethers.utils.formatUnits(
        ethers.BigNumber.from(`${data.startingPrice}`).add(
          ethers.BigNumber.from(
            Math.min(
              data.duration,
              Math.ceil(today.getTime() / 1000.0 - data.startAt),
            ),
          )
            .mul(
              ethers.BigNumber.from(`${data.endingPrice}`).sub(
                ethers.BigNumber.from(`${data.startingPrice}`),
              ),
            )
            .div(ethers.BigNumber.from(data.duration)),
        ),
        9,
      );

      return Number(mcrtAmt);
    }
  };

  function nFormatter(num, digits) {
    const lookup = [
      { value: 1, symbol: '' },
      { value: 1e3, symbol: 'K' },
      { value: 1e6, symbol: 'M' },
      { value: 1e9, symbol: 'G' },
      { value: 1e12, symbol: 'T' },
      { value: 1e15, symbol: 'P' },
      { value: 1e18, symbol: 'E' },
    ];
    const rx = /\.0+$|(\.[0-9]*[1-9])0+$/;
    var item = lookup
      .slice()
      .reverse()
      .find(function (item) {
        return num >= item.value;
      });
    return item
      ? (num / item.value).toFixed(digits).replace(rx, '$1') + item.symbol
      : '0';
  }

  const getThumbnailImage = (url) => {
    const prevLinks = [
      'QmTPtJSxd3YWXNKfYLYkVVUe4nazk3yxhp2XQfgARzcs7y',
      'QmX1dhoSQqq9eMyzzFBSAYgQ5119Ap8h7VC2evppGs93W9',
      'QmNdDumUU4KDSScPkohP4fH2T5YwxNJTbQf4Cy8D3TcP59',
    ];
    const newLinks = [
      'QmVHWN3nP2vpMjT2w1s3fRRvHPEGtGHXoTQbkYEXZHsZBq',
      'QmbYXYGUYbWPALxh66MUbrUH7FC7eUqa8rXeVMQMDbGrga',
      'QmX8UUL4vE3NzRaXMivCoyL9TR6PR2A9GpvcVw9UdXB3Yb',
    ];

    let response;
    prevLinks.forEach((it, idx) => {
      if (url.includes(it)) {
        response = url.replace(it, newLinks[idx]);
      }
    });

    return response || url;
  };

  useEffect(() => {
    getBNBPrice();
    getMcrtPrice().then((response) => {
      setMCRTPrice(response);
    });
  }, []);

  useEffect(() => {
    getMCRTInfo();
  }, [ctNFT]);

  useEffect(() => {
    if (collection) {
      const contractAddress = getNftContractAddress();
      dispatch(fetchMagicNftsAsync(0, undefined, true));

      getRecentlySoldNfts(contractAddress).then((response) => {
        setSoldNfts(response.slice(0, 5));
      });
    }
  }, [collection]);


  useEffect(() => {
    if (listedNfts) {
      setRecentNfts(listedNfts.slice(0, 5));
    }
  }, [listedNfts]);


  return (
    <div className="marketplace container px-md-auto px-3">
      {/* banner */}
      <div className="marketplace__banner">
        <div className="marketplace__banner-content">
          <div className="marketplace__banner--info">
            <h1>MagicCraft NFT Marketplace</h1>
            <p>
              Experience true ownership and freedom with MagicCraft's NFT
              Marketplace. Buy, sell, and trade game assets directly on the
              blockchain, securely stored in your own wallet. Embark on your
              blockchain adventure today!
            </p>
          </div>
          {breakpoint.lg && (
            <div className="marketplace__banner--pages marketplace__banner--pages--desktop">
              <button
                onClick={onBtnMarketplace}
                className="marketplace__banner--pages--btnInventory"
              >
                Marketplace
              </button>
              <button onClick={onBtnMint}>Minting Page</button>
            </div>
          )}

          {breakpoint.sm && !breakpoint.lg && (
            <div className="marketplace__banner--pages marketplace__banner--pages--tablet">
              <button
                onClick={onBtnMarketplace}
                className="marketplace__banner--pages--btnInventory"
              >
                Marketplace
              </button>
              <button onClick={onBtnMint}>Minting Page</button>
            </div>
          )}
        </div>
      </div>
      {!breakpoint.sm && (
        <div className="marketplace__banner--pages marketplace__banner--pages--mobile">
          <button
            onClick={onBtnMarketplace}
            className="marketplace__banner--pages--btnInventory"
          >
            Marketplace
          </button>
          <button onClick={onBtnMint} style={{ whiteSpace: 'nowrap' }}>
            Minting Page
          </button>
        </div>
      )}
      <div className="marketplace__data-container">
        <div className="marketplace__data-container-data">
          <img loading="lazy" src={shop} alt="shop-icon" />
          <div className="marketplace__data-container-data__text">
            <p>Market Cap</p>
            <h1>
              <span>Ξ</span>
              {MCRTData.marketCap ? numberWithCommas(MCRTData.marketCap) : 0}
            </h1>
          </div>
        </div>
        <div className="marketplace__data-container-data">
          <img loading="lazy" src={receipt} alt="receipt-icon" />
          <div className="marketplace__data-container-data__text">
            <p>Total Volume</p>
            <h1>
              <span>Ξ</span>
              {MCRTData.totalVolume
                ? numberWithCommas(MCRTData.totalVolume)
                : 0}
            </h1>
          </div>
        </div>
        <div className="marketplace__data-container-data">
          <img loading="lazy" src={people} alt="people-icon" />
          <div className="marketplace__data-container-data__text">
            <p>NFT Holders</p>
            <h1>{MCRTData.holders ? numberWithCommas(MCRTData.holders) : 0}</h1>
          </div>
        </div>
      </div>{' '}
      {/* <CollectionButton /> */}
      {/* <div className="marketplace__time-btn-container">
        <div
          onClick={() => setActiveTimeBtn('24h')}
          className={`${activeTimeBtn === '24h' ? 'active' : ''}`}
        >
          <p>Last 24 Hours</p>
        </div>
        <div
          onClick={() => setActiveTimeBtn('7d')}
          className={`${activeTimeBtn === '7d' ? 'active' : ''}`}
        >
          <p>7 Days</p>
        </div>
        <div
          onClick={() => setActiveTimeBtn('30d')}
          className={`${activeTimeBtn === '30d' ? 'active' : ''}`}
        >
          <p>30 Days</p>
        </div>
      </div> */}
      <div className="marketplace__wrapper">
        <section className="marketplace__wrapper__transactions-container">
          <h1 className="marketplace__wrapper__transactions-container__heading">
            Recently Listed
          </h1>
          <div className="marketplace__wrapper__transactions-container__buttons-container">
            <div
              className={`marketplace__wrapper__transactions-container__buttons-container__button ${listedType === 'characters' ? 'active' : ''
                }`}
              onClick={() => setListedType('characters')}
            >
              <img loading="lazy" src={swordsIcon} alt="swords-icon" />
              <h2>Characters</h2>
            </div>
            {/* <div
              className={`marketplace__wrapper__transactions-container__buttons-container__button ${
                listedType === 'items' ? 'active' : ''
              }`}
            >
              <img loading="lazy" src={chestIcon} alt="chest-icon" />
              <h2>Items</h2>
            </div>
            <div
              className={`marketplace__wrapper__transactions-container__buttons-container__button ${
                listedType === 'lands' ? 'active' : ''
              }`}
            >
              <img loading="lazy" src={directionsIcon} alt="directions-icon" />
              <h2>Lands</h2>
            </div> */}
          </div>
          <div className="marketplace__wrapper__transactions-container__listed-items-container">
            {(recentNfts || []).map((nft, index) => {
              const rarity = returnRarity(nft);
              const isVideo = nft.image?.includes?.('mp4');
              const _class = returnClass(nft);

              return (
                <div
                  className="marketplace__wrapper__transactions-container__listed-items-container__item"
                  key={index}
                  onClick={() => goToNftDetail(nft)}
                >
                  <div className="marketplace__wrapper__transactions-container__listed-items-container__item-nft-container">
                    {/* {rarity && (
                      <img
                        src={getRarityFrame(rarity)}
                        style={{ position: 'absolute', zIndex: '11' }}
                        alt="rarity-frame"
                      />
                    )} */}
                    <NftMedia
                      src={getThumbnailImage(nft?.image)}
                      video={isVideo}
                      alt="nft"
                      className="marketplace__wrapper__transactions-container__listed-items-container__item-nft"
                      style={{ pointerEvents: 'none', userSelect: 'none' }}
                    />
                    {rarity && <p className="rarity-mobile">{rarity}</p>}
                  </div>
                  <div className="info">
                    <div className="marketplace__wrapper__transactions-container__listed-items-container__item-detail">
                      <h1>{(nft.name || '').split(',')[0]}</h1>
                      {_class && (
                        <div
                          className="marketplace__wrapper__transactions-container__listed-items-container__item-detail-class"
                          style={{ backgroundColor: getNameBgColor(nft.name || '') }}
                        >
                          {_class}
                        </div>
                      )}
                      {rarity && <p className="rarity-desktop">{rarity}</p>}
                    </div>
                    <div className="users">
                      <div className="marketplace__wrapper__transactions-container__listed-items-container__item-seller">
                        <p>Seller</p>
                        <h2>
                          {nft.seller.substring(0, 4).concat('..') +
                            nft.seller.substring(nft.seller.length - 3)}
                        </h2>
                      </div>
                    </div>
                  </div>
                  <div className="marketplace__wrapper__transactions-container__listed-items-container__item-price">
                    <div>
                      <div className="marketplace__wrapper__transactions-container__listed-items-container__item-price-mcrt">
                        {nft.isMCRT ? (
                          <img loading="lazy" src={mcrtLogo} alt="mcrt-logo" />
                        ) : (
                          <img loading="lazy" src={bnbLogo} alt="bnb-logo" />
                        )}
                        <h2>
                          {getCurrentPrice(nft) === 0
                            ? null
                            : breakpoint.sm
                              ? numberWithCommas(getCurrentPrice(nft).toFixed(0))
                              : numberWithCommas(
                                nFormatter(getCurrentPrice(nft).toFixed(0), 1),
                              )}
                        </h2>
                      </div>
                      <p style={{ fontSize: 14, color: '#fff' }}>
                        $
                        {getCurrentPrice(nft) === 0
                          ? null
                          : nft.isMCRT
                            ? breakpoint.sm
                              ? numberWithCommas(
                                (getCurrentPrice(nft) * MCRTPrice).toFixed(2),
                              )
                              : numberWithCommas(
                                nFormatter(
                                  (getCurrentPrice(nft) * MCRTPrice).toFixed(2),
                                  1,
                                ),
                              )
                            : breakpoint.sm
                              ? numberWithCommas(
                                (getCurrentPrice(nft) * BNBPrice).toFixed(2),
                              )
                              : numberWithCommas(
                                nFormatter(
                                  (getCurrentPrice(nft) * BNBPrice).toFixed(2),
                                  1,
                                ),
                              )}
                      </p>
                    </div>
                    <p>
                      {timeDifference(
                        moment().valueOf(),
                        new Date(nft.createdAt).getTime(),
                      )}
                    </p>
                  </div>
                </div>
              );
            })}
          </div>
          <Nav.Link
            href="/marketplace/explorer"
            className="marketplace__wrapper__transactions-container__listed-items-container__see-more"
          >
            <p>View more on Marketplace</p>
            <BiChevronRight />
          </Nav.Link>
        </section>
        <section className="marketplace__wrapper__transactions-container">
          <h1 className="marketplace__wrapper__transactions-container__heading">
            Recently Sold
          </h1>
          <div className="marketplace__wrapper__transactions-container__buttons-container">
            <div
              className={`marketplace__wrapper__transactions-container__buttons-container__button ${listedType === 'characters' ? 'active' : ''
                }`}
              onClick={() => setListedType('characters')}
            >
              <img loading="lazy" src={swordsIcon} alt="swords-icon" />
              <h2>Characters</h2>
            </div>
            {/* <div
              className={`marketplace__wrapper__transactions-container__buttons-container__button ${
                listedType === 'items' ? 'active' : ''
              }`}
            >
              <img loading="lazy" src={chestIcon} alt="chest-icon" />
              <h2>Items</h2>
            </div>
            <div
              className={`marketplace__wrapper__transactions-container__buttons-container__button ${
                listedType === 'lands' ? 'active' : ''
              }`}
            >
              <img loading="lazy" src={directionsIcon} alt="directions-icon" />
              <h2>Lands</h2>
            </div> */}
          </div>
          <div className="marketplace__wrapper__transactions-container__sold-items-container">
            {(soldNfts || []).filter((nft) => nft?.nftItem).map((nft, index) => {
              const isVideo = (nft.nftItem?.image || '').includes('mp4');
              // Currency: from API isMCRT (sold payment token); fallback from nftItem. Icon is set below (MCRT = mcrtLogo, else BNB = bnbLogo).
              const soldIsMCRT = nft.isMCRT ?? nft.nftItem?.isMCRT ?? true;
              // Price: API sends totalPrice (GraphQL) and price (number); fallback to nftItem if present.
              const rawPrice =
                Number(nft.totalPrice) ||
                Number(nft.price) ||
                Number(nft.nftItem?.totalPrice) ||
                Number(nft.nftItem?.price) ||
                0;
              const isLikelyWeiScale = rawPrice >= 1e12;
              const amountForDisplay = isLikelyWeiScale ? showAmount(rawPrice, soldIsMCRT) : rawPrice;
              const hasPrice = rawPrice > 0;

              const rarity = returnRarity(nft.nftItem);

              const _class = returnClass(nft.nftItem);

              return (
                <div
                  className="marketplace__wrapper__transactions-container__sold-items-container__item"
                  key={index}
                  onClick={() => goToNftDetail(nft)}
                >
                  <div className="marketplace__wrapper__transactions-container__sold-items-container__item-nft-container">
                    {/* {rarity && (
                      <img
                        src={getRarityFrame(rarity)}
                        style={{ position: 'absolute', zIndex: '11' }}
                        alt="rarity-frame"
                      />
                    )} */}
                    <NftMedia
                      src={getThumbnailImage(nft.nftItem?.image)}
                      video={isVideo}
                      alt="nft"
                      className="marketplace__wrapper__transactions-container__sold-items-container__item-nft"
                      style={{ pointerEvents: 'none', userSelect: 'none' }}
                    />
                    {rarity && <p className="rarity-mobile">{rarity}</p>}
                  </div>
                  <div className="info">
                    <div className="marketplace__wrapper__transactions-container__sold-items-container__item-detail">
                      <h1>{(nft.nftItem.name || '').split(',')[0]}</h1>
                      {_class && (
                        <div
                          className="marketplace__wrapper__transactions-container__sold-items-container__item-detail-class"
                          style={{
                            backgroundColor: getNameBgColor(nft.nftItem.name || ''),
                          }}
                        >
                          {_class}
                        </div>
                      )}
                      {rarity && <p className="rarity-desktop">{rarity}</p>}
                    </div>
                    <div className="users">
                      <div className="marketplace__wrapper__transactions-container__sold-items-container__item-buyer">
                        <p>Buyer</p>
                        <h2>
                          {nft.buyer.substring(0, 4).concat('..') +
                            nft.buyer.substring(nft.buyer.length - 3)}
                        </h2>
                      </div>
                      <div className="marketplace__wrapper__transactions-container__sold-items-container__item-seller">
                        <p>Seller</p>
                        <h2>
                          {nft.seller.substring(0, 4).concat('..') +
                            nft.seller.substring(nft.seller.length - 3)}
                        </h2>
                      </div>
                    </div>
                  </div>
                  <div className="marketplace__wrapper__transactions-container__sold-items-container__item-price">
                    <div>
                      <div className="marketplace__wrapper__transactions-container__sold-items-container__item-price-mcrt">
                        {soldIsMCRT ? (
                          <img loading="lazy" src={mcrtLogo} alt="mcrt-logo" />
                        ) : (
                          <img loading="lazy" src={bnbLogo} alt="bnb-logo" />
                        )}
                        <h2>
                          {hasPrice
                            ? breakpoint.sm
                              ? numberWithCommas(
                                Number(amountForDisplay).toFixed(0),
                              )
                              : numberWithCommas(
                                nFormatter(
                                  Number(amountForDisplay).toFixed(0),
                                  1,
                                ),
                              )
                            : '—'}
                        </h2>
                      </div>
                      <p style={{ fontSize: 14, color: '#fff' }}>
                        {hasPrice
                          ? `$${soldIsMCRT
                            ? breakpoint.sm
                              ? numberWithCommas(
                                (Number(amountForDisplay) * MCRTPrice).toFixed(2),
                              )
                              : numberWithCommas(
                                nFormatter(
                                  (Number(amountForDisplay) * MCRTPrice).toFixed(2),
                                  1,
                                ),
                              )
                            : breakpoint.sm
                              ? numberWithCommas(
                                (Number(amountForDisplay) * BNBPrice).toFixed(2),
                              )
                              : numberWithCommas(
                                nFormatter(
                                  (Number(amountForDisplay) * BNBPrice).toFixed(2),
                                  1,
                                ),
                              )}`
                          : '—'}
                      </p>
                    </div>
                    <p>{timeDifference(moment().valueOf(), nft.soldAt)}</p>
                  </div>
                </div>
              );
            })}
          </div>

          <Nav.Link
            href="/marketplace/explorer"
            className="marketplace__wrapper__transactions-container__listed-items-container__see-more"
          >
            <p>View more on Marketplace</p>
            <BiChevronRight />
          </Nav.Link>
        </section>
      </div>
      <div className="d-flex  row-gap-2 justify-content-between align-items-center pb-5 py-lg-5">
        <div>
          <h2 className="mb-0">Trending</h2>
        </div>
        <div>
          <Link to="/marketplace/explorer" className="btn   rounded-pill btn-outline-info px-4 d-flex align-items-center">View All</Link>
        </div>
      </div>


      <div className="row px-0 justify-content-center">
        {loading ? (
          Array?.from({ length: 6 })?.map((_, index) => (
            <div className="col-xl-2 col-lg-4 col-md-6 col-6 mb-3" key={index}>
              <SmallCardSkeleton />
            </div>
          ))
        ) : listedNfts?.length === 0 ? (
          <div
            style={{
              transform: 'translateY(200px)',
              textAlign: 'center',
              padding: '0 1rem',
              color: 'white',
            }}
          >
            No items are listed in the marketplace
          </div>
        ) : (
          listedNfts?.slice(0, 6)?.map((inventoryNft, index) => {
            const price = getCurrentPrice(inventoryNft);
            const priceDollar = price ? price * BNBPrice : null;
            const mcrtPrice = price ? price : null;
            const mcrtPriceDollar = price ? price * MCRTPrice : null;

            return (
              <div
                className="col-xl-2 col-lg-4 col-md-6 col-6"
                key={inventoryNft.tokenID}
              >
                <InventoryItem
                  dashboard
                  data={inventoryNft}
                  onClick={() => goToNftDetail(inventoryNft)}
                  price={inventoryNft.isMCRT ? null : price}
                  priceDollar={inventoryNft.isMCRT ? null : priceDollar}
                  mcrtPrice={inventoryNft.isMCRT ? mcrtPrice : null}
                  mcrtPriceDollar={inventoryNft.isMCRT ? mcrtPriceDollar : null}
                />
              </div>
            );
          })
        )}
      </div>


      {/* {!breakpoint.sm && (
        <div className="marketplace__banner--pages marketplace__banner--pages--mobile">
          <button onClick={onBtnMarketplace}>Inventory</button>
          <button onClick={onBtnMint}>Minting Page</button>
        </div>
      )} */}
      {/* <div className="marketplace__marketdata">
        <Tabs defaultActiveKey="home" id="uncontrolled-tab-example">
          <Tab eventKey="home" defaultChecked title="Last 24 Hours">
            <div className="marketplace__marketdata--marketInfo">
              <div className="marketplace__marketdata--marketInfo--infoItem">
                <img loading="lazy" src={marketIcon} />
                <div className="marketplace__marketdata--marketInfo--infoItem--infoText">
                  <h5>Market Cap</h5>
                  <h2>Ξ 19.400</h2>
                </div>
              </div>
              <div className="marketplace__marketdata--marketInfo--infoItem">
                <img loading="lazy" src={volumeIcon} />
                <div className="marketplace__marketdata--marketInfo--infoItem--infoText">
                  <h5>Total Volume</h5>
                  <h2>Ξ 3.521</h2>
                </div>
              </div>
              <div className="marketplace__marketdata--marketInfo--infoItem">
                <img loading="lazy" src={userIcon} />
                <div className="marketplace__marketdata--marketInfo--infoItem--infoText">
                  <h5>Users</h5>
                  <h2>3,521</h2>
                </div>
              </div>
            </div>
          </Tab>
          <Tab eventKey="profile" title="7 Days"></Tab>
          <Tab eventKey="contact" title="30 Days"></Tab>
        </Tabs>
      </div> */}
      {/* <div className="marketplace__itemList">
        {!breakpoint.sm && <h5>Recently Listed</h5>}

        <div className="marketplace__itemList--listed">
          {breakpoint.lg && <h5>Recently Listed</h5>}
          <Tabs defaultActiveKey="Characters" id="listed">
            <Tab eventKey="Characters" title="Characters">
              <NFTListedItem />
              <NFTListedItem />
              <NFTListedItem />
            </Tab>
            <Tab eventKey="Items" title="Items"></Tab>
            <Tab eventKey="Land" title="Land"></Tab>
          </Tabs>
          {breakpoint.lg && (
            <div className="marketplace__itemList--sold--details">
              View more on Marketplace
              <img loading="lazy" src={arrowNext} />
            </div>
          )}
        </div>
        {!breakpoint.sm && (
          <div className="marketplace__itemList--sold--details">
            View more on Marketplace
            <img loading="lazy" src={arrowNext} />
          </div>
        )}
        {!breakpoint.sm && <h5>Recently Sold</h5>}
        <div className="marketplace__itemList--sold">
          {breakpoint.lg && <h5>Recently Sold</h5>}
          <Tabs defaultActiveKey="Characters1" id="sold">
            <Tab eventKey="Characters1" title="Characters">
              <NFTSoldItem />
              <NFTSoldItem />
              <NFTSoldItem />
            </Tab>
            <Tab eventKey="Items1" title="Items"></Tab>
            <Tab eventKey="Land1" title="Land"></Tab>
          </Tabs>
          {breakpoint.lg && (
            <div className="marketplace__itemList--sold--details">
              View more on Marketplace
              <img loading="lazy" src={arrowNext} />
            </div>
          )}
        </div>
        {!breakpoint.sm && (
          <div className="marketplace__itemList--sold--details">
            View more on Marketplace
            <img loading="lazy" src={arrowNext} />
          </div>
        )}
      </div> */}
      {/* <div className="vstaking">NFTMarketplace</div> */}
    </div>
  );
};

export default NFTMarketplace;
